import { CircleNotch, MagnifyingGlass, XCircle } from "@phosphor-icons/react";
import { clsx } from "clsx";
import { type ForwardedRef, forwardRef } from "react";

import { Input, type InputProps } from "common/components/ui/Input";

import RenderIf from "../RenderIf";

interface SearchInputProps extends Omit<InputProps, "leftComponent"> {
  onClear: () => void;
  isLoading?: boolean;
}
function SearchInput(
  {
    onClear,
    rightComponent,
    value,
    isLoading = false,
    className,
    ...rest
  }: SearchInputProps,
  ref: ForwardedRef<HTMLInputElement>,
) {
  return (
    <Input
      {...rest}
      className={clsx(className, "w-full !rounded-full")}
      value={value}
      ref={ref}
      leftComponent={<MagnifyingGlass />}
      rightComponent={
        <>
          {rightComponent}

          <RenderIf condition={isLoading}>
            <CircleNotch className="animate-spin fill-black-400" />
          </RenderIf>

          <RenderIf condition={!isLoading && !!value}>
            <button type="button" aria-label="Clear input" onClick={onClear}>
              <XCircle weight="fill" />
            </button>
          </RenderIf>
        </>
      }
    />
  );
}

SearchInput.displayName = "SearchInput";

const SearchInputWithRef = forwardRef(SearchInput);

export default SearchInputWithRef;
